import trainings from './routes'

export default [...trainings] as const
